import { DateFormats, formatDate } from 'src/utils/time';
import styled from 'styled-components';

interface Props {
  date: string;
}

export const InlineDateAndTime = (props: Props) => (
  <Container>
    <Date>{formatDate(props.date, DateFormats.DAY_MONTH_YEAR)}</Date>
    <Time>{formatDate(props.date, DateFormats.HOUR_MINUTE_AMPM)}</Time>
  </Container>
);

const Container = styled.div`
  display: flex;
`;

const Date = styled.p`
  padding-right: 10px;
  border-right: 1px solid
    ${(props) => props.theme.atlas.semantic.color.outline.default};
`;

const Time = styled.p`
  padding-left: 10px;
`;
